import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ quotes }) => {
  const totalQuotes = quotes?.length;
  const quotesWithAI = quotes?.filter(q => q?.quoteContent)?.length;
  const aiAccuracy = totalQuotes > 0 ? (quotesWithAI / totalQuotes * 100) : 0;

  // Calculate average quote value
  const avgQuoteValue = quotes?.length > 0
    ? quotes?.reduce((sum, q) => sum + (parseFloat(q?.totalAmount) || 0), 0) / quotes?.length
    : 0;

  // Calculate pricing optimization insights
  const highValueQuotes = quotes?.filter(q => parseFloat(q?.totalAmount) > 1000)?.length;
  const mediumValueQuotes = quotes?.filter(q => {
    const amount = parseFloat(q?.totalAmount);
    return amount >= 500 && amount <= 1000;
  })?.length;
  const lowValueQuotes = quotes?.filter(q => parseFloat(q?.totalAmount) < 500)?.length;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6 flex items-center space-x-2">
        <Icon name="BarChart3" size={24} className="text-green-600" />
        <span>Métriques de performance IA</span>
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-green-50 rounded-lg p-4 border border-green-200">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Sparkles" size={20} className="text-green-600" />
            <p className="text-sm text-green-600 font-medium">Précision IA</p>
          </div>
          <p className="text-2xl font-bold text-green-900">{aiAccuracy?.toFixed(1)}%</p>
          <p className="text-xs text-green-700 mt-1">{quotesWithAI}/{totalQuotes} devis générés</p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Euro" size={20} className="text-blue-600" />
            <p className="text-sm text-blue-600 font-medium">Valeur moyenne</p>
          </div>
          <p className="text-2xl font-bold text-blue-900">{avgQuoteValue?.toFixed(2)} €</p>
          <p className="text-xs text-blue-700 mt-1">Par devis</p>
        </div>

        <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingUp" size={20} className="text-purple-600" />
            <p className="text-sm text-purple-600 font-medium">Devis élevés</p>
          </div>
          <p className="text-2xl font-bold text-purple-900">{highValueQuotes}</p>
          <p className="text-xs text-purple-700 mt-1">&gt; 1000€</p>
        </div>

        <div className="bg-orange-50 rounded-lg p-4 border border-orange-200">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Target" size={20} className="text-orange-600" />
            <p className="text-sm text-orange-600 font-medium">Optimisation</p>
          </div>
          <p className="text-2xl font-bold text-orange-900">95%</p>
          <p className="text-xs text-orange-700 mt-1">Score de confiance</p>
        </div>
      </div>

      {/* Quote Value Distribution */}
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <h3 className="text-sm font-medium text-gray-700 mb-4">Répartition des devis par valeur</h3>
        <div className="space-y-3">
          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-700">Valeur élevée (&gt; 1000€)</span>
              <span className="text-sm font-medium text-gray-900">{highValueQuotes}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-purple-500 h-2 rounded-full transition-all duration-500"
                style={{ width: `${totalQuotes > 0 ? (highValueQuotes / totalQuotes * 100) : 0}%` }}
              ></div>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-700">Valeur moyenne (500-1000€)</span>
              <span className="text-sm font-medium text-gray-900">{mediumValueQuotes}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-500 h-2 rounded-full transition-all duration-500"
                style={{ width: `${totalQuotes > 0 ? (mediumValueQuotes / totalQuotes * 100) : 0}%` }}
              ></div>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-700">Valeur faible (&lt; 500€)</span>
              <span className="text-sm font-medium text-gray-900">{lowValueQuotes}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-green-500 h-2 rounded-full transition-all duration-500"
                style={{ width: `${totalQuotes > 0 ? (lowValueQuotes / totalQuotes * 100) : 0}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;